// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.8_webpack@5.102.1_@swc+core@1.13.5_esbuild@0.28.0_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* multi-agent route — animations layered on top of shell-web design tokens */

@keyframes ma-pulse-glow {
  0%, 100% {
    box-shadow: 0 0 16px hsl(var(--accent-glow) / 0.25);
  }
  50% {
    box-shadow: 0 0 32px hsl(var(--accent-glow) / 0.55);
  }
}

.ma-running {
  animation: ma-pulse-glow 2.4s ease-in-out infinite;
}

@keyframes ma-dash-flow {
  to {
    stroke-dashoffset: -24;
  }
}

/* Idle-hero orbit — the SObject tokens actually revolve around the cloud, and
   each token counter-rotates so its label stays upright. */
@keyframes ma-orbit {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ma-orbit-rev {
  to {
    transform: rotate(-360deg);
  }
}
@keyframes ma-orbit-glow {
  0%, 100% {
    opacity: 0.45;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.08);
  }
}
@media (prefers-reduced-motion: reduce) {
  /* The glow and the hub pulse join the two rotations: a reader who asked for no motion meant the
     whole centrepiece, not just the parts that travel. */
  .ma-orbit-ring,
  .ma-orbit-chip,
  .ma-orbit-glow,
  .ma-orbit-hub {
    animation: none !important;
  }
}

.react-flow__edge.ma-edge-active path {
  stroke-dasharray: 6 4;
  animation: ma-dash-flow 0.8s linear infinite;
}

@keyframes ma-fade-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ma-route .react-flow__node {
  animation: ma-fade-in 220ms ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/pages/multi-agent/styles/multi-agent.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;EACE;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;AACF;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;2DAC2D;AAC3D;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;AACA;EACE;yDACuD;EACvD;;;;IAIE,0BAA0B;EAC5B;AACF;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* multi-agent route — animations layered on top of shell-web design tokens */\n\n@keyframes ma-pulse-glow {\n  0%, 100% {\n    box-shadow: 0 0 16px hsl(var(--accent-glow) / 0.25);\n  }\n  50% {\n    box-shadow: 0 0 32px hsl(var(--accent-glow) / 0.55);\n  }\n}\n\n.ma-running {\n  animation: ma-pulse-glow 2.4s ease-in-out infinite;\n}\n\n@keyframes ma-dash-flow {\n  to {\n    stroke-dashoffset: -24;\n  }\n}\n\n/* Idle-hero orbit — the SObject tokens actually revolve around the cloud, and\n   each token counter-rotates so its label stays upright. */\n@keyframes ma-orbit {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@keyframes ma-orbit-rev {\n  to {\n    transform: rotate(-360deg);\n  }\n}\n@keyframes ma-orbit-glow {\n  0%, 100% {\n    opacity: 0.45;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.08);\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  /* The glow and the hub pulse join the two rotations: a reader who asked for no motion meant the\n     whole centrepiece, not just the parts that travel. */\n  .ma-orbit-ring,\n  .ma-orbit-chip,\n  .ma-orbit-glow,\n  .ma-orbit-hub {\n    animation: none !important;\n  }\n}\n\n.react-flow__edge.ma-edge-active path {\n  stroke-dasharray: 6 4;\n  animation: ma-dash-flow 0.8s linear infinite;\n}\n\n@keyframes ma-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ma-route .react-flow__node {\n  animation: ma-fade-in 220ms ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
